import React from 'react';
import clsx from 'clsx';

import Button from '../Button';
import type { ButtonProps } from '../Button';

type TopPanelProps = {
  children?: React.ReactNode;

  topLeftContent?: React.ReactNode;

  buttons?: (ButtonProps | false)[];
  buttonsLeftContent?: React.ReactNode;
  buttonsRightContent?: React.ReactNode;
};

const TopPanel: React.FC<TopPanelProps> = ({
  buttons: initialButtons,
  children,
  topLeftContent,
  buttonsLeftContent,
  buttonsRightContent,
}) => {
  const buttons = initialButtons?.filter(Boolean) || [];
  const hasTopLeft = !!topLeftContent;
  const hasButtons = Boolean(
    buttons?.length || buttonsLeftContent || buttonsRightContent
  );

  return (
    <div className={clsx('flex gap-md shrink-0 flex-col')}>
      {(hasButtons || hasTopLeft) && (
        <div className="flex flex-col flex-wrap gap-md md:flex-row">
          {topLeftContent}
          {hasButtons && (
            <>
              <div className="ml-auto flex md:flex-row gap-md flex-wrap shrink-0 flex-col justify-end">
                {buttonsLeftContent}
                {buttons?.map((button, index) => (
                  <Button key={String(index)} width="small" {...button} />
                ))}
                {buttonsRightContent}
              </div>
            </>
          )}
        </div>
      )}
      {children && (
        <div className="flex md:flex-row gap-md flex-wrap shrink-0 flex-col justify-end">
          {children}
        </div>
      )}
    </div>
  );
};

export default React.memo(TopPanel) as typeof TopPanel;
